export default __webpack_public_path__ + "static/media/forks.c6132a73.svg";